import { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'react-proptypes';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { currencyFormatter } from '@dnhb/formatters';
import { dispatchMapper } from '../../../shared/wizard/actions';
import { shapeOutput, shapeInput } from '../config';

class OutputResults extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const {
      sync, output, input,
    } = this.props;

    const mortgageTypes = {
      1: 'Aflossingsvrije',
      6: 'Annuïteiten',
      7: 'Lineaire',
    };


    const debtOptions = {
      title: {
        text: '',
      },
      legend: {
        enabled: false,
      },
      credits: {
        enabled: false,
      },
      tooltip: {
        pointFormatter() { return (`<span>${this.series.name}: <b>${currencyFormatter(this.y)}</b></span>`); },
      },
      xAxis: [
        {
          tickInterval: 24,
          title: {
            enabled: true,
            text: 'Looptijd in jaren',
          },
          labels: {
            formatter() {
              return (this.value / 12);
            },
          },
        },
      ],
      yAxis: [{
        min: 0,
        labels: { formatter() { return currencyFormatter(this.value); } },
        title: { enabled: true, text: 'Hoogte Hypotheekschuld' },
      }],
      series: [{
        name: 'Schuldrest',
        dashStyle: 'Solid',
        dataLabels: { enabled: false },
        data: output.debt_graph || [],
      }],
    };

    const monthlyCostsOptions = {
      title: {
        text: '',
      },
      legend: {
        enabled: false,
      },
      credits: {
        enabled: false,
      },
      tooltip: {
        pointFormatter() { return (`<span>${this.series.name}: <b>${currencyFormatter(this.y)}</b></span>`); },
      },
      xAxis: [
        {
          tickInterval: 24,
          title: {
            enabled: true,
            text: 'Looptijd in jaren',
          },
          labels: {
            formatter() {
              return (this.value / 12);
            },
          },
        },
      ],
      yAxis: [{
        min: 0,
        labels: { formatter() { return currencyFormatter(this.value); } },
        title: { enabled: true, text: 'Maandbedrag' },
      }],
      series: [{
        name: 'Maandlasten',
        dashStyle: 'Solid',
        dataLabels: { enabled: false },
        data: output.monthly_payments_graph || [],
      }],
    };

    return (
      <div className="results">
        <div className="result-graph">
          <p>
            Verloop van de
            <strong> Hypotheekschuld </strong>
          </p>
          <HighchartsReact
            highcharts={Highcharts}
            options={debtOptions}
          />
          <p>
            <strong>
              {mortgageTypes[input.mortgage_type]}
              &nbsp;
            </strong>
            Hypotheek
          </p>
        </div>
        <div className="result-graph">
          <p>
            Verloop van het
            <strong> Maandbedrag </strong>
          </p>
          <HighchartsReact
            highcharts={Highcharts}
            options={monthlyCostsOptions}
          />
          <p>
            <strong>
              {mortgageTypes[input.mortgage_type]}
              &nbsp;
            </strong>
            Hypotheek
          </p>
        </div>
        <footer className="no-mobile">
          <button type="button" onClick={() => sync('show_disclaimer', true)}>Disclaimer</button>
        </footer>
      </div>
    );
  }
}

OutputResults.propTypes = {
  sync: PropTypes.func.isRequired,
  output: shapeOutput.isRequired,
  input: shapeInput.isRequired,
};

OutputResults.defaultProps = {};

export default connect(state => ({
  output: state.output,
  input: state.input,
  app: state.app,
}), dispatchMapper)(OutputResults);
